import { useLocales } from 'api/localeApi';
import { StyledSelect } from 'styles/overrides';
import _ from 'lodash';
import { filterOptions } from 'utils/formatUtils';

export default function LocalesSelector({ onChange, value, ...restProps }) {
  const { data = [], isLoading } = useLocales({
    options: {
      select: (response) =>
        _.map(response, ({ code, name }) => ({
          label: name,
          value: code,
        })) ?? [],
    },
  });

  return (
    <StyledSelect
      options={data}
      loading={isLoading}
      showSearch
      optionFilterProp="label"
      filterOption={filterOptions}
      {...restProps}
      onChange={onChange}
      value={value}
    />
  );
}
